import { isOfType } from '../helpers'
import { IdOf } from './common'

export type ObjectTreeId = IdOf<'objectTree'>

const geoModuleEntityTypesArray = [
  'Map',
  'Lithology',
  'Saturation',
  'Marker',
  'Well',
  'Fault',
  'Polygon',
] as const

export type GeoModuleEntityType = (typeof geoModuleEntityTypesArray)[number]

export const isDroppableInGeoModule = isOfType(geoModuleEntityTypesArray)
